import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@configs/routes';
import { TIMEOUTS } from '@constants/auth.constants';
import {
  UsePasswordResetOptions,
  UsePasswordResetReturn,
} from './usePasswordResetModal.types';

export const usePasswordResetModal = ({
  successTimeout = TIMEOUTS.PASSWORD_RESET_SUCCESS,
  onPasswordResetSent,
  onClose,
}: UsePasswordResetOptions): UsePasswordResetReturn => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleResetPassword = (userEmail: string) => {
    if (!userEmail?.trim()) {
      return;
    }

    setIsLoading(true);
    onPasswordResetSent?.(userEmail);

    setTimeout(() => {
      navigate(ROUTES.AUTH.PASSWORD_MIGRATION);
      onClose();
      setIsLoading(false);
    }, successTimeout);
  };

  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  const buttonText = (() => {
    if (isLoading) return t('sendingResetLink') || '';
    return t('resetPasswordButton') || '';
  })();

  return {
    isLoading,
    handleResetPassword,
    handleClose,
    buttonText,
  };
};

export default usePasswordResetModal;
